var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$store.getters.isMiseApp)?_c('div',{staticClass:"text-center pa-8 pb-offset",staticStyle:{"opacity":"0.7"}},[_c('img',{staticClass:"pb-4",staticStyle:{"width":"250px"},attrs:{"src":"img/volontapp-login.png","alt":"VolontApp"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }